import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Button,
  IconButton,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  const navItems = ['Home', 'About', 'Services', 'Experience', 'Projects', 'Contact'];

  return (
    <AppBar
      position="fixed"
      elevation={scrolled ? 4 : 0}
      sx={{
        background: scrolled ? 'rgba(11, 13, 23, 0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(20px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(255, 255, 255, 0.08)' : 'none',
        transition: 'all 0.3s ease',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar sx={{ justifyContent: 'space-between', py: 2 }}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: "'Playfair Display', serif",
              fontWeight: 900,
              background: 'linear-gradient(135deg, #00F5FF, #FF6B35)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '-0.02em',
              cursor: 'pointer',
            }}
            onClick={() => scrollToSection('home')}
          >
            KM-BIZZ
          </Typography>

          {/* Desktop Menu */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3 }}>
            {navItems.map((item) => (
              <Button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                sx={{
                  color: 'text.secondary',
                  fontSize: '0.95rem',
                  fontWeight: 500,
                  letterSpacing: '0.03em',
                  position: 'relative',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: 0,
                    height: '2px',
                    background: 'linear-gradient(90deg, #00F5FF, #FF6B35)',
                    transition: 'width 0.3s ease',
                  },
                  '&:hover': {
                    color: 'primary.main',
                    background: 'transparent',
                    '&::after': {
                      width: '100%',
                    },
                  },
                }}
              >
                {item}
              </Button>
            ))}
          </Box>

          {/* Mobile Menu Button */}
          <IconButton
            sx={{ display: { xs: 'flex', md: 'none' }, color: 'primary.main' }}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </Toolbar>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <Box
            sx={{
              display: { xs: 'block', md: 'none' },
              pb: 2,
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item}
                fullWidth
                onClick={() => scrollToSection(item.toLowerCase())}
                sx={{
                  color: 'text.secondary',
                  justifyContent: 'flex-start',
                  py: 1.5,
                  '&:hover': {
                    color: 'primary.main',
                    background: 'rgba(0, 245, 255, 0.1)',
                  },
                }}
              >
                {item}
              </Button>
            ))}
          </Box>
        )}
      </Container>
    </AppBar>
  );
};

export default Navigation;
